module.exports = __webpack_public_path__ + "bin/d7124b24d0c7768f597ced25a98073c8.png";